import React from 'react';
import './PatronDisplay.css';
import PatronAvatar from './PatronAvatar';

const FORM_NAME = [
  'Дымка',
  'Сгусток света',
  'Проступает силуэт',
  'Почти телесный',
  'Телесный патронус',
];

function PatronDisplay({ patron, inventory = [] }) {
  const renderStars = (level) => '⭐'.repeat(level) + '☆'.repeat(5 - level);

  const worn = inventory.filter((i) => i.equipped);
  const shelf = inventory.filter((i) => !i.slot || i.slot === 'room');

  return (
    <div className="patron-display">
      <div className="patron-card">
        <div className="patron-avatar">
          <PatronAvatar patron={patron} inventory={inventory} size={220} />
        </div>

        <div className="patron-info">
          <h2>{patron.name || 'Твой Патронус'}</h2>
          <p className="patron-form">{FORM_NAME[Math.min(patron.level, 5) - 1]}</p>

          <div className="stats-grid">
            <div className="stat">
              <span className="stat-label">Форма</span>
              <span className="stat-value">{renderStars(patron.level)}</span>
            </div>

            <div className="stat">
              <span className="stat-label">Свет</span>
              <div className="happiness-bar">
                <div
                  className="happiness-fill"
                  style={{
                    width: `${patron.happiness}%`,
                    background: patron.color || '#a5b4fc',
                  }}
                />
              </div>
              <span className="stat-value">{patron.happiness}/100</span>
              <span className="stat-note">копится только из воспоминаний</span>
            </div>

            <div className="stat">
              <span className="stat-label">Монеты</span>
              <span className="stat-value stat-coins">💰 {patron.coins}</span>
            </div>
          </div>
        </div>
      </div>

      {worn.length > 0 && (
        <div className="worn-section">
          <h3>На нём сейчас</h3>
          <div className="worn-list">
            {worn.map((i) => (
              <span key={i.item_id} className="worn-chip">
                {i.emoji} {i.name}
              </span>
            ))}
          </div>
        </div>
      )}

      {shelf.length > 0 && (
        <div className="worn-section">
          <h3>🗄 На полке — {shelf.length}</h3>
          <div className="worn-list">
            {shelf.slice(0, 8).map((i) => (
              <span key={i.item_id} className="worn-chip" title={i.memory_txt}>
                {i.emoji}
              </span>
            ))}
          </div>
        </div>
      )}

      <div className="patron-tips">
        <h3>💡 Как это работает</h3>
        <ul>
          <li>Записывай хорошие моменты — от них растёт свет</li>
          <li>Из моментов рождаются сувениры, их можно купить в лавке</li>
          <li>Чем больше света, тем плотнее форма патронуса</li>
          <li>Когда грустно — он напомнит тебе твои же дни</li>
        </ul>
      </div>
    </div>
  );
}

export default PatronDisplay;
